function initPageHeaderViewers() {
  document.querySelectorAll(".page-header__viewer[data-video-id]").forEach(function (el, idx) {
    if (el.dataset.initialized === "true") return;

    var videoId = el.getAttribute("data-video-id");
    if (!videoId) return;

    var containerId = "page-header-s7viewer-" + idx;
    el.id = containerId;
    el.dataset.initialized = "true";

    var viewer = new s7viewers.VideoViewer({
      containerId: containerId,
      params: {
        asset: videoId,
        config: "bhsf/Video",
        serverurl: "https://s7d9.scene7.com/is/image/",
        contenturl: "https://s7d9.scene7.com/is/content/",
        videoserverurl: "https://s7d9.scene7.com/is/content",
        autoplay: "1",
        loop: "1",
        mute: "1",
        controls: "none"
      },
      handlers: {
        initComplete: function () {
          var player = viewer.videoplayer;
          if (player) {
            var videoEl = el.querySelector('video');
            if (videoEl) {
              videoEl.muted = true;
              videoEl.setAttribute('muted', ''); // For some browsers
            }
            player.mute();
            player.play();
          }
          var controls = el.querySelector(".s7controlbar");
          if (controls) {
            controls.style.display = "none";
          }

          const playButton = document.querySelector(".hero-video-play");
          const pauseButton = document.querySelector(".hero-video-pause");
          if (!playButton && !pauseButton) return;

          playButton.addEventListener("click", function () {
              player.play();
              $(this).toggleClass('is-active', false).siblings().toggleClass('is-active', true);
          });

          pauseButton.addEventListener("click", function () {
              player.pause();
              $(this).toggleClass('is-active', false).siblings().toggleClass('is-active', true);
          });
        }
      }
    });

    viewer.init();
    el.viewer = viewer;
  });
}

document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector(".page-header__viewer[data-video-id]")) {
    Scene7Loader.load(initPageHeaderViewers);
  }
});
